var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.computeOnlyIds),function(image){return _c('compute-image',{key:("compute:" + image),attrs:{"imageId":("compute:" + image)}})}),_vm._v(" "),_vm._l((_vm.imageIds),function(image){return _c('compute-image',{key:image,attrs:{"imageId":image}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edab0e46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ComputeImages.vue
// module id = ehnu
// module chunks = 1